import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstituteTypeListPage } from '@/features/instituteTypes/pages/InstituteTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/institute-types')({
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Institute Types">
      <Suspense fallback={<PageLoader />}>
        <InstituteTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
